function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { tap } from 'rxjs';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { BaseFeaturesComponent } from '../_base/base-features.component';
var TarjetaMenuComponentCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  TarjetaMenuComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos", "appConfigService"];
  function TarjetaMenuComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, TarjetaMenuComponentCtrl);
    _this = _callSuper(this, TarjetaMenuComponentCtrl, [appConfigService]);
    _defineProperty(_this, "dirty", false);
    _defineProperty(_this, "esNuevo", false);
    _defineProperty(_this, "defaultactive", '');
    _defineProperty(_this, "editaAccesoPublico", false);
    _defineProperty(_this, "editaAceptaLOPD", false);
    _defineProperty(_this, "editaAceptarRecaptcha", false);
    _this.$element = $element;
    _this.$timeout = $timeout;
    _this.$log = $log;
    _this.NotifService = NotifService;
    _this.AccesoDatos = AccesoDatos;
    return _this;
  }
  _inherits(TarjetaMenuComponentCtrl, _BaseFeaturesComponen);
  return _createClass(TarjetaMenuComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this.$log.info('[TarjetaMenuComponentCtrl] onInit');
      this.forms = this.menu.forms || [];
      this.esNuevo = !this.menu.m.idmen;
      this.defaultactive = this.esNuevo ? '' : 'active';
      this.autoUnsub(
      //
      this._flags.pipe(tap(function (flags) {
        _this2.editaAccesoPublico = flags.editaAccesoPublico;
        _this2.editaAceptaLOPD = flags.editaAceptarLOPD;
        _this2.editaAceptarRecaptcha = flags.editaAceptarRecaptcha;
      })).subscribe());
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this3 = this;
      this.$timeout(function () {
        return _this3.$element.find('select').formSelect();
      }, 100);
    }
  }, {
    key: "guardarMenu",
    value: function guardarMenu() {
      var _this4 = this;
      if (this._esnuevo()) {
        this.menu.forms = this.forms;
        this.AccesoDatos.GestionMenu_CLIENT.nuevoMenu(this.menu).then(function (response) {
          _this4.menu = response;
          _this4.forms = _this4.menu.forms;
          _this4.dirty = false;
        });
      } else {
        this.AccesoDatos.GestionMenu_CLIENT.actualizaMenu(this.menu).then(function (response) {
          _this4.menu = response;
          _this4.forms = _this4.menu.forms;
          _this4.dirty = false;
        });
      }
    }
  }, {
    key: "_esnuevo",
    value: function _esnuevo() {
      return !this.menu.m.idmen;
    }
  }, {
    key: "verFormularios",
    value: function verFormularios() {
      if (this._esnuevo()) {
        this.NotifService.aviso('Entry is not saved, first save changes');
        return;
      }
      this.verForms = !this.verForms;
    }
  }, {
    key: "nuevoForm",
    value: function nuevoForm() {
      var _nuevo = {};
      _nuevo.m = {};
      _nuevo.m.idmensuper = this.menu.m.idmen;
      this.forms.push(_nuevo);
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('tarjetaMenu', {
  bindings: {
    menu: '<',
    formulars: '<',
    principal: '<'
  },
  controller: TarjetaMenuComponentCtrl,
  template: require('./tarjeta-menu.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-menu/tarjeta-menu.component.html"
});